<ng-container *ngIf="state | async as versionGate">
  <section class="version-gate-card" *ngIf="versionGate.kind === 'required'">
    <h1 id="version-gate-title" tabindex="-1" cdkFocusInitial>Update required</h1>
    <p>
      You are using version {{versionGate.currentVersion}}. Version
      {{versionGate.latestVersion}} is now available.
    </p>
    <p>Reload Team Admin to continue with the latest version.</p>
    <div class="version-gate-actions">
      <button type="button" (click)="versionPolicyService.reload()">Reload to update</button>
    </div>
  </section>
</ng-container>
